<template>
  <svg :width="size" :height="size" :viewBox="viewBox">
    <path d="M 24.074219 33.851562 C 14.746094 33.851562 7.152344 26.257812 7.152344 16.929688 C 7.152344 7.59375 14.746094 0 24.074219 0 C 33.402344 0 40.996094 7.59375 40.996094 16.921875 C 40.996094 26.257812 33.402344 33.851562 24.074219 33.851562 Z M 24.074219 7.882812 C 19.085938 7.882812 15.027344 11.945312 15.027344 16.929688 C 15.027344 21.917969 19.085938 25.96875 24.074219 25.96875 C 29.0625 25.96875 33.121094 21.910156 33.121094 16.929688 C 33.121094 11.933594 29.0625 7.882812 24.074219 7.882812 Z M 24.074219 7.882812 "/>
    <path d="M 30.609375 16.921875 C 30.609375 20.53125 27.683594 23.457031 24.074219 23.457031 C 20.464844 23.457031 17.539062 20.53125 17.539062 16.921875 C 17.539062 13.3125 20.464844 10.386719 24.074219 10.386719 C 27.683594 10.386719 30.609375 13.3125 30.609375 16.921875 Z M 30.609375 16.921875 "/>
    <path d="M 9.113281 28.546875 L 1.566406 41.363281 L 8.632812 42.253906 L 12.835938 48 L 20.324219 35.289062 C 15.523438 34.632812 11.8125 32.34375 9.113281 28.546875 Z M 9.113281 28.546875 "/>
    <path d="M 38.886719 28.546875 L 46.445312 41.363281 L 39.375 42.253906 L 35.175781 48 L 27.683594 35.289062 C 32.476562 34.632812 36.1875 32.34375 38.886719 28.546875 Z M 38.886719 28.546875 "/>
  </svg>
</template>

<script>
export default {
  props: {
    size: {
      type: [Number, String],
      default: 48
    },
    box: {
      type: [Number, String],
      default: 48
    }
  },
  computed: {
    viewBox() {
      return `0 0 ${this.box} ${this.box}`
    }
  }
}

</script>